import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function DatePickerMui({
  label,
  onChange,
  value,
  format,
  ...rest
}: {
  label?: string;
  onChange: (date?: any) => void;
  value: string | null | object;
  InputProps?: object;
  sx?: object;
  maxDate?: any;
  minDate?: any;
  views?: any;
  format?: any;
}) {
  return (
    <DatePicker
      label={label}
      onChange={(e: any) => onChange(e)}
      value={value}
      format={format || 'DD-MM-YYYY'}
      {...rest}
    />
  );
}
